// TODO - move to backend

export enum Routes {
  PodLeadCenter = '/',
  AdminFinance = '/admin-finance',
  ProjectBillingProfiles = '/project-billing-profiles',
}

export enum AdminRoutes {
  GlobalConfigs = '/global-configs',
  BudgetApprovals = '/budget-approvals',
  BulkUploadGuardrails = '/bulk-upload-guardrails',
}

export const POD_LEAD_CENTER = 'Pod Lead Center';
